/* OA Complete the Look (9-14-26 v3). Delegated listeners so it keeps working after the cart drawer re-renders. */
(function () {
  if (window.__oaStlInit) return;
  window.__oaStlInit = true;

  function money(cents) {
    var n = cents / 100;
    return '$' + (cents % 100 ? n.toFixed(2) : n.toFixed(0));
  }

  function closeAll() {
    document.querySelectorAll('[data-oa-card]').forEach(function (c) { c.hidden = true; });
  }

  function openCard(dot) {
    var root = dot.closest('[data-oa-stl]');
    var card = root && root.querySelector('[data-oa-card]');
    if (!card) return;
    closeAll();
    card.querySelector('[data-oa-card-img]').src = dot.dataset.img || '';
    card.querySelector('[data-oa-card-img]').alt = dot.dataset.title || '';
    card.querySelector('[data-oa-card-name]').textContent = dot.dataset.title || '';
    card.querySelector('[data-oa-card-price]').textContent = dot.dataset.price || '';
    var link = card.querySelector('[data-oa-card-link]');
    if (dot.dataset.url) { link.href = dot.dataset.url; } else { link.removeAttribute('href'); }
    var err = card.querySelector('[data-oa-card-err]'); err.hidden = true; err.textContent = '';
    var sel = card.querySelector('[data-oa-card-size]');
    sel.innerHTML = '';
    var variants = [];
    try { variants = JSON.parse(dot.dataset.variants || '[]'); } catch (e) { variants = []; }
    variants.forEach(function (v) {
      var o = document.createElement('option');
      o.value = v.id;
      o.textContent = v.t + ' \u2014 ' + money(v.p);
      if (String(v.id) === String(dot.dataset.default || '')) o.selected = true;
      sel.appendChild(o);
    });
    var add = card.querySelector('[data-oa-card-add]');
    add.disabled = variants.length === 0;
    add.textContent = variants.length ? 'Add to bag' : 'Sold out';
    card.hidden = false;
    if (root.classList.contains('oa-stl--drawer')) card.scrollIntoView({ block: 'nearest', behavior: 'smooth' });
  }

  function addVariant(id, btn, errEl) {
    if (!id) return;
    if (errEl) errEl.hidden = true;
    btn.disabled = true;
    var orig = btn.textContent;
    btn.textContent = 'Adding\u2026';
    var drawer = document.querySelector('cart-drawer');
    var onCartPage = window.location.pathname.indexOf('/cart') === 0;
    var body = { items: [{ id: id, quantity: 1 }] };
    if (drawer && drawer.getSectionsToRender && !onCartPage) {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; }).join(',');
      body.sections_url = window.location.pathname;
    }
    var url = (window.routes && window.routes.cart_add_url) || '/cart/add';
    fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) {
          if (errEl) { errEl.textContent = res.description || res.message || 'Could not add. Please try again.'; errEl.hidden = false; }
          btn.disabled = false; btn.textContent = orig;
          return;
        }
        btn.textContent = 'Added';
        btn.classList.add('is-added');
        if (onCartPage || !drawer || !drawer.renderContents) {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          return;
        }
        var item = Array.isArray(res.items) && res.items.length ? res.items[0] : res;
        setTimeout(function () {
          drawer.renderContents(Object.assign({}, item, { sections: res.sections }));
          if (typeof publish === 'function' && window.PUB_SUB_EVENTS) {
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'oa-shop-the-look', productVariantId: id, cartData: res });
          }
        }, 350);
      })
      .catch(function () {
        if (errEl) { errEl.textContent = 'Could not add. Please try again.'; errEl.hidden = false; }
        btn.disabled = false; btn.textContent = orig;
      });
  }

  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t.closest) return;
    var quick = t.closest('[data-oa-quick]');
    if (quick) { e.preventDefault(); addVariant(quick.dataset.variant, quick, null); return; }
    var dot = t.closest('[data-oa-dot]');
    if (dot) { e.preventDefault(); openCard(dot); return; }
    if (t.closest('[data-oa-close]')) { closeAll(); return; }
    var add = t.closest('[data-oa-card-add]');
    if (add) {
      e.preventDefault();
      var card = add.closest('[data-oa-card]');
      var sel = card.querySelector('[data-oa-card-size]');
      addVariant(sel && sel.value, add, card.querySelector('[data-oa-card-err]'));
      return;
    }
    if (!t.closest('[data-oa-card]') && !t.closest('[data-oa-stl]')) closeAll();
  });
})();
